export default function () {
  document.addEventListener('click', (e) => {
    const target = e.target.closest('[data-mobile-menu-expand-collapse]');
    if (!target) return;

    // We don't want this to bubble up, as opening a sub-menu would also trigger closing of the parent menu
    e.stopPropagation();

    const currentMenu = target.closest('[data-mobile-menu-expands]');

    // Base max height is just the height of the title
    let maxHeight = currentMenu.querySelector('[data-mobile-menu-title]').offsetHeight;

    // If the menu isn't open, add the sibling's height to make the menu animate open
    if (!currentMenu.classList.contains('MobileMenu__item--open')) {
      const siblingHeight = currentMenu.querySelector('[data-mobile-menu-list]').offsetHeight;
      maxHeight += siblingHeight;
    }

    // Animate the current menu open or closed
    currentMenu.style.maxHeight = `${maxHeight}px`;
    currentMenu.classList.toggle('MobileMenu__item--open');

    // Does this menu have a parent that also needs to grow or shrink?
    const parentMenu = currentMenu.parentElement.closest('[data-mobile-menu-expands]');
    if (parentMenu) {
      // Temporarily give the parent a huge max height...this lets the child animate freely.
      parentMenu.style.maxHeight = '10000px';
      setTimeout(() => {
        // Now the animation has finished, essentially double click the parent to open/close it, forcing it to resize instantly.
        // With the resize finished, the parent menu can be expanded/collapsed with perfectly smooth transitions again. :)
        parentMenu.querySelectorAll('[data-mobile-menu-expands]').forEach((menu) => {
          menu.click();
          menu.click();
        });
      }, 250);
    }
  });

  // Don't let final links bubble up and cause parent menu to close
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-mobile-menu-link]')) {
      e.stopPropagation();
    }
  });
}
